import { render, staticRenderFns } from "./ProfileComponent.vue?vue&type=template&id=10d6ab58&scoped=true"
import script from "./ProfileComponent.vue?vue&type=script&lang=js"
export * from "./ProfileComponent.vue?vue&type=script&lang=js"
import style0 from "./ProfileComponent.vue?vue&type=style&index=0&id=10d6ab58&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d6ab58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10d6ab58')) {
      api.createRecord('10d6ab58', component.options)
    } else {
      api.reload('10d6ab58', component.options)
    }
    module.hot.accept("./ProfileComponent.vue?vue&type=template&id=10d6ab58&scoped=true", function () {
      api.rerender('10d6ab58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/user/ProfileComponent.vue"
export default component.exports